// ── DÜNYA ÜLKELERİ (Türkçe isim + bayrak) ─────────────────────────────────
// Kapsamlı liste — BM üyesi + gözlemci + yaygın bölgeler
export const WORLD_COUNTRIES = [
  { value:'Afganistan', flag:'🇦🇫' },
  { value:'Almanya', flag:'🇩🇪' },
  { value:'ABD', flag:'🇺🇸' },
  { value:'Andorra', flag:'🇦🇩' },
  { value:'Angola', flag:'🇦🇴' },
  { value:'Antigua ve Barbuda', flag:'🇦🇬' },
  { value:'Arjantin', flag:'🇦🇷' },
  { value:'Arnavutluk', flag:'🇦🇱' },
  { value:'Avustralya', flag:'🇦🇺' },
  { value:'Avusturya', flag:'🇦🇹' },
  { value:'Azerbaycan', flag:'🇦🇿' },
  { value:'Bahamalar', flag:'🇧🇸' },
  { value:'Bahreyn', flag:'🇧🇭' },
  { value:'Bangladeş', flag:'🇧🇩' },
  { value:'Barbados', flag:'🇧🇧' },
  { value:'Belarus', flag:'🇧🇾' },
  { value:'Belçika', flag:'🇧🇪' },
  { value:'Belize', flag:'🇧🇿' },
  { value:'Benin', flag:'🇧🇯' },
  { value:'Bhutan', flag:'🇧🇹' },
  { value:'Birleşik Arap Emirlikleri', flag:'🇦🇪' },
  { value:'Bolivya', flag:'🇧🇴' },
  { value:'Bosna-Hersek', flag:'🇧🇦' },
  { value:'Botsvana', flag:'🇧🇼' },
  { value:'Brezilya', flag:'🇧🇷' },
  { value:'Brunei', flag:'🇧🇳' },
  { value:'Bulgaristan', flag:'🇧🇬' },
  { value:'Burkina Faso', flag:'🇧🇫' },
  { value:'Burundi', flag:'🇧🇮' },
  { value:'Cezayir', flag:'🇩🇿' },
  { value:'Cibuti', flag:'🇩🇯' },
  { value:'Çad', flag:'🇹🇩' },
  { value:'Çekya', flag:'🇨🇿' },
  { value:'Çin', flag:'🇨🇳' },
  { value:'Danimarka', flag:'🇩🇰' },
  { value:'Doğu Timor', flag:'🇹🇱' },
  { value:'Dominik Cumhuriyeti', flag:'🇩🇴' },
  { value:'Dominika', flag:'🇩🇲' },
  { value:'Ekvador', flag:'🇪🇨' },
  { value:'Ekvator Ginesi', flag:'🇬🇶' },
  { value:'El Salvador', flag:'🇸🇻' },
  { value:'Endonezya', flag:'🇮🇩' },
  { value:'Eritre', flag:'🇪🇷' },
  { value:'Ermenistan', flag:'🇦🇲' },
  { value:'Estonya', flag:'🇪🇪' },
  { value:'Esvatini', flag:'🇸🇿' },
  { value:'Etiyopya', flag:'🇪🇹' },
  { value:'Fas', flag:'🇲🇦' },
  { value:'Fiji', flag:'🇫🇯' },
  { value:'Fildişi Sahili', flag:'🇨🇮' },
  { value:'Filipinler', flag:'🇵🇭' },
  { value:'Filistin', flag:'🇵🇸' },
  { value:'Finlandiya', flag:'🇫🇮' },
  { value:'Fransa', flag:'🇫🇷' },
  { value:'Gabon', flag:'🇬🇦' },
  { value:'Gambiya', flag:'🇬🇲' },
  { value:'Gana', flag:'🇬🇭' },
  { value:'Gine', flag:'🇬🇳' },
  { value:'Gine-Bissau', flag:'🇬🇼' },
  { value:'Grenada', flag:'🇬🇩' },
  { value:'Guatemala', flag:'🇬🇹' },
  { value:'Guyana', flag:'🇬🇾' },
  { value:'Güney Afrika', flag:'🇿🇦' },
  { value:'Güney Kore', flag:'🇰🇷' },
  { value:'Güney Sudan', flag:'🇸🇸' },
  { value:'Gürcistan', flag:'🇬🇪' },
  { value:'Haiti', flag:'🇭🇹' },
  { value:'Hırvatistan', flag:'🇭🇷' },
  { value:'Hindistan', flag:'🇮🇳' },
  { value:'Hollanda', flag:'🇳🇱' },
  { value:'Honduras', flag:'🇭🇳' },
  { value:'Irak', flag:'🇮🇶' },
  { value:'İngiltere', flag:'🇬🇧' },
  { value:'İran', flag:'🇮🇷' },
  { value:'İrlanda', flag:'🇮🇪' },
  { value:'İspanya', flag:'🇪🇸' },
  { value:'İsrail', flag:'🇮🇱' },
  { value:'İsveç', flag:'🇸🇪' },
  { value:'İsviçre', flag:'🇨🇭' },
  { value:'İtalya', flag:'🇮🇹' },
  { value:'İzlanda', flag:'🇮🇸' },
  { value:'Jamaika', flag:'🇯🇲' },
  { value:'Japonya', flag:'🇯🇵' },
  { value:'Kamboçya', flag:'🇰🇭' },
  { value:'Kamerun', flag:'🇨🇲' },
  { value:'Kanada', flag:'🇨🇦' },
  { value:'Karadağ', flag:'🇲🇪' },
  { value:'Katar', flag:'🇶🇦' },
  { value:'Kazakistan', flag:'🇰🇿' },
  { value:'Kenya', flag:'🇰🇪' },
  { value:'Kıbrıs', flag:'🇨🇾' },
  { value:'Kırgızistan', flag:'🇰🇬' },
  { value:'Kiribati', flag:'🇰🇮' },
  { value:'Kolombiya', flag:'🇨🇴' },
  { value:'Komorlar', flag:'🇰🇲' },
  { value:'Kongo', flag:'🇨🇬' },
  { value:'Kongo Demokratik Cumhuriyeti', flag:'🇨🇩' },
  { value:'Kosta Rika', flag:'🇨🇷' },
  { value:'Küba', flag:'🇨🇺' },
  { value:'Kuveyt', flag:'🇰🇼' },
  { value:'Kuzey Kore', flag:'🇰🇵' },
  { value:'Kuzey Makedonya', flag:'🇲🇰' },
  { value:'Laos', flag:'🇱🇦' },
  { value:'Lesoto', flag:'🇱🇸' },
  { value:'Letonya', flag:'🇱🇻' },
  { value:'Liberya', flag:'🇱🇷' },
  { value:'Libya', flag:'🇱🇾' },
  { value:'Lihtenştayn', flag:'🇱🇮' },
  { value:'Litvanya', flag:'🇱🇹' },
  { value:'Lübnan', flag:'🇱🇧' },
  { value:'Lüksemburg', flag:'🇱🇺' },
  { value:'Macaristan', flag:'🇭🇺' },
  { value:'Madagaskar', flag:'🇲🇬' },
  { value:'Malavi', flag:'🇲🇼' },
  { value:'Maldivler', flag:'🇲🇻' },
  { value:'Malezya', flag:'🇲🇾' },
  { value:'Mali', flag:'🇲🇱' },
  { value:'Malta', flag:'🇲🇹' },
  { value:'Marshall Adaları', flag:'🇲🇭' },
  { value:'Mauritius', flag:'🇲🇺' },
  { value:'Meksika', flag:'🇲🇽' },
  { value:'Mikronezya', flag:'🇫🇲' },
  { value:'Mısır', flag:'🇪🇬' },
  { value:'Moğolistan', flag:'🇲🇳' },
  { value:'Moldova', flag:'🇲🇩' },
  { value:'Monako', flag:'🇲🇨' },
  { value:'Moritanya', flag:'🇲🇷' },
  { value:'Mozambik', flag:'🇲🇿' },
  { value:'Myanmar', flag:'🇲🇲' },
  { value:'Namibya', flag:'🇳🇦' },
  { value:'Nauru', flag:'🇳🇷' },
  { value:'Nepal', flag:'🇳🇵' },
  { value:'Nijer', flag:'🇳🇪' },
  { value:'Nijerya', flag:'🇳🇬' },
  { value:'Nikaragua', flag:'🇳🇮' },
  { value:'Norveç', flag:'🇳🇴' },
  { value:'Orta Afrika Cumhuriyeti', flag:'🇨🇫' },
  { value:'Özbekistan', flag:'🇺🇿' },
  { value:'Pakistan', flag:'🇵🇰' },
  { value:'Palau', flag:'🇵🇼' },
  { value:'Panama', flag:'🇵🇦' },
  { value:'Papua Yeni Gine', flag:'🇵🇬' },
  { value:'Paraguay', flag:'🇵🇾' },
  { value:'Peru', flag:'🇵🇪' },
  { value:'Polonya', flag:'🇵🇱' },
  { value:'Portekiz', flag:'🇵🇹' },
  { value:'Romanya', flag:'🇷🇴' },
  { value:'Ruanda', flag:'🇷🇼' },
  { value:'Rusya', flag:'🇷🇺' },
  { value:'Saint Kitts ve Nevis', flag:'🇰🇳' },
  { value:'Saint Lucia', flag:'🇱🇨' },
  { value:'Saint Vincent ve Grenadinler', flag:'🇻🇨' },
  { value:'Samoa', flag:'🇼🇸' },
  { value:'San Marino', flag:'🇸🇲' },
  { value:'São Tomé ve Príncipe', flag:'🇸🇹' },
  { value:'Senegal', flag:'🇸🇳' },
  { value:'Sırbistan', flag:'🇷🇸' },
  { value:'Sierra Leone', flag:'🇸🇱' },
  { value:'Singapur', flag:'🇸🇬' },
  { value:'Slovakya', flag:'🇸🇰' },
  { value:'Slovenya', flag:'🇸🇮' },
  { value:'Solomon Adaları', flag:'🇸🇧' },
  { value:'Somali', flag:'🇸🇴' },
  { value:'Sri Lanka', flag:'🇱🇰' },
  { value:'Sudan', flag:'🇸🇩' },
  { value:'Surinam', flag:'🇸🇷' },
  { value:'Suriye', flag:'🇸🇾' },
  { value:'Suudi Arabistan', flag:'🇸🇦' },
  { value:'Tacikistan', flag:'🇹🇯' },
  { value:'Tanzanya', flag:'🇹🇿' },
  { value:'Tayland', flag:'🇹🇭' },
  { value:'Tayvan', flag:'🇹🇼' },
  { value:'Togo', flag:'🇹🇬' },
  { value:'Tonga', flag:'🇹🇴' },
  { value:'Trinidad ve Tobago', flag:'🇹🇹' },
  { value:'Tunus', flag:'🇹🇳' },
  { value:'Tuvalu', flag:'🇹🇻' },
  { value:'Türkiye', flag:'🇹🇷' },
  { value:'Türkmenistan', flag:'🇹🇲' },
  { value:'Uganda', flag:'🇺🇬' },
  { value:'Ukrayna', flag:'🇺🇦' },
  { value:'Umman', flag:'🇴🇲' },
  { value:'Ürdün', flag:'🇯🇴' },
  { value:'Uruguay', flag:'🇺🇾' },
  { value:'Vanuatu', flag:'🇻🇺' },
  { value:'Vatikan', flag:'🇻🇦' },
  { value:'Venezuela', flag:'🇻🇪' },
  { value:'Vietnam', flag:'🇻🇳' },
  { value:'Yemen', flag:'🇾🇪' },
  { value:'Yeni Zelanda', flag:'🇳🇿' },
  { value:'Yunanistan', flag:'🇬🇷' },
  { value:'Zambiya', flag:'🇿🇲' },
  { value:'Zimbabve', flag:'🇿🇼' },
];

// Bayrak lookup
export const getCountryFlag = (name) =>
  WORLD_COUNTRIES.find(c => c.value === name)?.flag || '🌍';

// ── ÖNEMLİ ŞEHİRLER (Ülke → şehirler eşleştirmesi) ────────────────────────
// Çok kapsamlı liste — her ülke için en büyük / en bilinen şehirler
export const CITIES_BY_COUNTRY = {
  'Türkiye': ['Ankara','İstanbul','İzmir','Bursa','Antalya','Adana','Konya','Gaziantep','Şanlıurfa','Mersin','Diyarbakır','Kayseri','Hatay','Manisa','Samsun','Balıkesir','Trabzon','Van','Aydın','Denizli','Sakarya','Muğla','Eskişehir','Erzurum','Tekirdağ','Malatya','Mardin','Ordu','Afyonkarahisar','Elazığ','Kahramanmaraş','Tokat','Ağrı','Kocaeli','Çanakkale','Edirne','Bolu','Rize','Batman','Siirt','Şırnak','Hakkari'],
  'ABD': ['Washington D.C.','New York','Los Angeles','Chicago','Houston','Phoenix','Philadelphia','San Antonio','San Diego','Dallas','San Jose','Austin','Jacksonville','Fort Worth','Columbus','Charlotte','Indianapolis','San Francisco','Seattle','Denver','Boston','Nashville','Baltimore','Oklahoma City','Portland','Las Vegas','Memphis','Louisville','Milwaukee','Albuquerque','Atlanta','Miami','Minneapolis','Raleigh','Tampa','Cleveland','Honolulu','Salt Lake City'],
  'Almanya': ['Berlin','Hamburg','Münih','Köln','Frankfurt','Stuttgart','Düsseldorf','Leipzig','Dortmund','Essen','Bremen','Dresden','Hannover','Nürnberg','Bonn','Mannheim','Karlsruhe','Augsburg','Wiesbaden','Münster','Freiburg','Heidelberg'],
  'İngiltere': ['Londra','Manchester','Birmingham','Leeds','Glasgow','Liverpool','Edinburgh','Bristol','Sheffield','Newcastle','Nottingham','Leicester','Cardiff','Belfast','Oxford','Cambridge','Brighton','Southampton','Aberdeen','Dundee','Bath','York'],
  'Fransa': ['Paris','Marsilya','Lyon','Toulouse','Nice','Nantes','Strasbourg','Montpellier','Bordeaux','Lille','Rennes','Reims','Saint-Étienne','Toulon','Le Havre','Grenoble','Dijon','Angers','Nîmes','Clermont-Ferrand'],
  'Hollanda': ['Amsterdam','Rotterdam','Lahey','Utrecht','Eindhoven','Groningen','Tilburg','Almere','Breda','Nijmegen','Arnhem','Haarlem','Maastricht','Leiden','Delft'],
  'İsviçre': ['Bern','Zürih','Cenevre','Basel','Lozan','Winterthur','Luzern','St. Gallen','Lugano','Biel'],
  'Belçika': ['Brüksel','Antwerpen','Gent','Charleroi','Liège','Brugge','Namur','Leuven','Mons','Mechelen'],
  'İsveç': ['Stockholm','Göteborg','Malmö','Uppsala','Västerås','Örebro','Linköping','Helsingborg','Jönköping','Norrköping','Lund','Umeå'],
  'Norveç': ['Oslo','Bergen','Stavanger','Trondheim','Drammen','Fredrikstad','Kristiansand','Tromsø','Sandnes','Bodø'],
  'Kanada': ['Ottawa','Toronto','Montreal','Vancouver','Calgary','Edmonton','Winnipeg','Quebec City','Hamilton','Halifax','Victoria','Saskatoon','Regina','London','Kitchener'],
  'Japonya': ['Tokyo','Osaka','Yokohama','Nagoya','Sapporo','Kobe','Kyoto','Fukuoka','Kawasaki','Hiroshima','Sendai','Chiba','Kitakyushu','Nara'],
  'Avustralya': ['Canberra','Sidney','Melbourne','Brisbane','Perth','Adelaide','Gold Coast','Hobart','Darwin','Newcastle','Wollongong'],
  'İtalya': ['Roma','Milano','Napoli','Torino','Palermo','Cenova','Bologna','Floransa','Bari','Catania','Venedik','Verona','Messina','Padova','Trieste','Brescia','Parma','Pisa'],
  'İspanya': ['Madrid','Barselona','Valensiya','Sevilla','Zaragoza','Malaga','Murcia','Palma','Las Palmas','Bilbao','Alicante','Córdoba','Granada','Vigo'],
  'Portekiz': ['Lizbon','Porto','Amadora','Braga','Funchal','Coimbra','Setúbal','Almada'],
  'Yunanistan': ['Atina','Selanik','Patras','Heraklion','Larissa','Volos','Ioannina','Hanya','Rodos'],
  'Polonya': ['Varşova','Krakow','Lodz','Wroclaw','Poznan','Gdansk','Szczecin','Lublin','Katowice','Bydgoszcz'],
  'Çekya': ['Prag','Brno','Ostrava','Plzeň','Liberec','Olomouc','České Budějovice'],
  'Avusturya': ['Viyana','Graz','Linz','Salzburg','Innsbruck','Klagenfurt','Villach','Wels'],
  'Macaristan': ['Budapeşte','Debrecen','Szeged','Miskolc','Pécs','Győr','Nyíregyháza','Kecskemét'],
  'Romanya': ['Bükreş','Cluj-Napoca','Timișoara','Iași','Constanța','Craiova','Brașov','Galați','Ploiești'],
  'Bulgaristan': ['Sofya','Plovdiv','Varna','Burgaz','Ruse','Stara Zagora','Pleven'],
  'Hırvatistan': ['Zagreb','Split','Rijeka','Osijek','Zadar','Dubrovnik','Pula'],
  'Sırbistan': ['Belgrad','Novi Sad','Niš','Kragujevac','Subotica','Novi Pazar'],
  'Bosna-Hersek': ['Saraybosna','Banja Luka','Tuzla','Mostar','Zenica','Bijeljina'],
  'Karadağ': ['Podgorica','Nikšić','Budva','Bar','Kotor','Cetinje'],
  'Arnavutluk': ['Tiran','Durres','Vlora','Elbasan','Shkodra','Fier','Korçë'],
  'Kuzey Makedonya': ['Üsküp','Bitola','Kumanovo','Prilep','Ohrid','Tetovo'],
  'Slovenya': ['Ljubljana','Maribor','Celje','Kranj','Koper','Novo Mesto'],
  'Slovakya': ['Bratislava','Košice','Prešov','Žilina','Banská Bystrica','Nitra'],
  'Danimarka': ['Kopenhag','Aarhus','Odense','Aalborg','Esbjerg','Randers','Kolding'],
  'Finlandiya': ['Helsinki','Espoo','Tampere','Vantaa','Oulu','Turku','Jyväskylä','Lahti'],
  'İzlanda': ['Reykjavik','Kópavogur','Hafnarfjörður','Akureyri'],
  'İrlanda': ['Dublin','Cork','Limerick','Galway','Waterford','Drogheda'],
  'Rusya': ['Moskova','Sankt Petersburg','Novosibirsk','Yekaterinburg','Kazan','Nizhny Novgorod','Samara','Çelyabinsk','Omsk','Rostov-na-Donu','Ufa','Krasnoyarsk','Perm','Voronezh','Volgograd'],
  'Ukrayna': ['Kiev','Harkov','Odessa','Dnipro','Donetsk','Zaporijya','Lviv','Kryvyi Rih','Mykolayiv','Mariupol','Vinnitsa'],
  'Belarus': ['Minsk','Gomel','Mogilev','Vitebsk','Grodno','Brest'],
  'Gürcistan': ['Tiflis','Batum','Kutaisi','Rustavi','Zugdidi','Poti'],
  'Azerbaycan': ['Bakü','Gence','Sumgait','Mingaçevir','Şirvan','Lenkeran'],
  'Ermenistan': ['Yerevan','Gyumri','Vanadzor','Vagharshapat','Hrazdan'],
  'Kazakistan': ['Astana','Almatı','Şımkent','Karaganda','Aktobe','Taraz','Pavlodar'],
  'Özbekistan': ['Taşkent','Semerkant','Namangan','Buhara','Andijan','Fergana','Nukus'],
  'Kırgızistan': ['Bişkek','Oş','Jalal-Abad','Karakol','Tokmok','Batken'],
  'Türkmenistan': ['Aşkabat','Türkmenabat','Daşoguz','Mary','Balkanabat'],
  'Tacikistan': ['Duşanbe','Hucand','Kulob','Bokhtar','İstaravşan'],
  'Çin': ['Pekin','Şanghay','Guangzhou','Shenzhen','Chengdu','Wuhan','Hangzhou','Xi\'an','Nanjing','Chongqing','Tianjin','Suzhou','Qingdao','Dalian','Kunming','Hong Kong'],
  'Hindistan': ['Yeni Delhi','Mumbai','Bangalore','Haydarabad','Ahmedabad','Chennai','Kalküta','Pune','Jaipur','Lucknow','Kanpur','Nagpur','Indore','Bhopal','Surat'],
  'Pakistan': ['İslamabad','Karaçi','Lahor','Fayselabad','Ravalpindi','Multan','Peşaver','Quetta','Haydarabad'],
  'Bangladeş': ['Dakka','Chittagong','Khulna','Rajshahi','Sylhet','Rangpur','Comilla'],
  'İran': ['Tahran','Meşhed','İsfahan','Tebriz','Şiraz','Ahvaz','Kum','Kirmanşah','Urmiye','Reşt'],
  'Irak': ['Bağdat','Basra','Erbil','Musul','Süleymaniye','Kerkük','Necef','Kerbela','Nasiriye'],
  'Suriye': ['Şam','Halep','Humus','Lazkiye','Hama','Rakka','Haseke','Deyrezzor','İdlib','Tartus'],
  'Lübnan': ['Beyrut','Trablus','Sayda','Tyre','Junieh','Zahlé','Baalbek'],
  'Ürdün': ['Amman','Zarqa','Irbid','Aqaba','Madaba','Salt','Karak'],
  'İsrail': ['Tel Aviv','Kudüs','Hayfa','Beersheba','Holon','Netanya','Ashdod','Nazareth'],
  'Filistin': ['Ramallah','Gazze','Doğu Kudüs','Nablus','Hebron','Cenin','Beytüllahim','Tülkarem','Eriha'],
  'Suudi Arabistan': ['Riyad','Cidde','Mekke','Medine','Dammam','Taif','Tabuk','Abha','Buraydah','Khobar'],
  'Birleşik Arap Emirlikleri': ['Abu Dabi','Dubai','Şarja','Ajman','Ras el-Hayme','Fujairah','Ummülkayveyn'],
  'Katar': ['Doha','Al Wakrah','Al Khor','Al Rayyan','Umm Salal','Dukhan'],
  'Kuveyt': ['Kuveyt','Hawalli','Salmiya','Jahra','Farwaniya','Mangaf'],
  'Bahreyn': ['Manama','Muharraq','Riffa','Hamad Town','A\'ali','Isa Town'],
  'Umman': ['Muscat','Salalah','Sohar','Seeb','Nizwa','Ibri','Buraimi'],
  'Yemen': ['Sana','Aden','Taiz','Hodeyda','Mukalla','İbb','Dhamar','Amran'],
  'Mısır': ['Kahire','İskenderiye','Giza','Şubra el-Hayma','Port Said','Süveyş','Luksor','Asvan','İsmailia','Mansura'],
  'Fas': ['Rabat','Kazablanka','Marakeş','Fes','Tanca','Meknes','Agadir','Ujda','Kenitra'],
  'Tunus': ['Tunus','Sfax','Sousse','Kayravan','Bizerte','Gabes','Ariana'],
  'Cezayir': ['Cezayir','Oran','Konstantin','Annaba','Batna','Blida','Setif','Sidi Bel Abbès'],
  'Libya': ['Trablus','Bingazi','Misrata','Sebha','Zliten','Bayda','Zawiya'],
  'Sudan': ['Hartum','Omdurman','Hartum Kuzey','Port Sudan','Kassala','El Obeid','Nyala'],
  'Güney Sudan': ['Juba','Malakal','Wau','Bor','Yambio','Aweil','Rumbek'],
  'Etiyopya': ['Addis Ababa','Dire Dawa','Mekelle','Adama','Bahir Dar','Hawassa','Gondar','Jimma'],
  'Kenya': ['Nairobi','Mombasa','Kisumu','Nakuru','Eldoret','Thika','Malindi','Nyeri'],
  'Nijerya': ['Abuja','Lagos','Kano','Ibadan','Port Harcourt','Benin City','Kaduna','Maiduguri','Zaria','Jos','Ilorin','Enugu'],
  'Güney Afrika': ['Pretoria','Cape Town','Johannesburg','Durban','Port Elizabeth','Bloemfontein','East London','Pietermaritzburg','Polokwane','Nelspruit'],
  'Brezilya': ['Brasilia','São Paulo','Rio de Janeiro','Belo Horizonte','Salvador','Fortaleza','Recife','Porto Alegre','Curitiba','Manaus','Belém','Goiânia'],
  'Arjantin': ['Buenos Aires','Córdoba','Rosario','Mendoza','La Plata','San Miguel de Tucumán','Mar del Plata','Salta','Santa Fe','Bahía Blanca'],
  'Meksika': ['Mexico City','Guadalajara','Monterrey','Puebla','Tijuana','León','Ciudad Juárez','Mérida','Querétaro','Cancún','Aguascalientes','Morelia'],
  'Kolombiya': ['Bogotá','Medellín','Cali','Barranquilla','Cartagena','Cúcuta','Bucaramanga','Pereira','Santa Marta','İbagué'],
  'Şili': ['Santiago','Valparaíso','Concepción','La Serena','Antofagasta','Temuco','Rancagua','Talca','Arica','İquique'],
  'Peru': ['Lima','Arequipa','Trujillo','Chiclayo','Piura','İquitos','Cusco','Huancayo','Tacna','Chimbote'],
  'Venezuela': ['Caracas','Maracaibo','Valencia','Barquisimeto','Maracay','Ciudad Guayana','Barcelona','Maturín'],
  'Küba': ['Havana','Santiago de Cuba','Camagüey','Holguín','Santa Clara','Guantánamo','Bayamo'],
  'Endonezya': ['Jakarta','Surabaya','Bandung','Medan','Semarang','Makassar','Palembang','Tangerang','Denpasar','Yogyakarta'],
  'Malezya': ['Kuala Lumpur','George Town','Johor Bahru','İpoh','Shah Alam','Petaling Jaya','Kota Kinabalu','Kuching','Malacca','Alor Setar'],
  'Tayland': ['Bangkok','Chiang Mai','Pattaya','Nakhon Ratchasima','Chiang Rai','Phuket','Khon Kaen','Hat Yai','Udon Thani'],
  'Vietnam': ['Hanoi','Ho Chi Minh','Da Nang','Hai Phong','Can Tho','Nha Trang','Hue','Bien Hoa','Vung Tau'],
  'Filipinler': ['Manila','Quezon City','Davao','Cebu','Zamboanga','Taguig','Antipolo','Cagayan de Oro','Iloilo'],
  'Güney Kore': ['Seul','Busan','Incheon','Daegu','Daejeon','Gwangju','Suwon','Ulsan','Changwon','Goyang','Jeju'],
  'Singapur': ['Singapur'],
  'Kamboçya': ['Phnom Penh','Siem Reap','Battambang','Sihanoukville','Kampong Cham'],
  'Myanmar': ['Naypyidaw','Yangon','Mandalay','Mawlamyine','Bago','Pathein','Taunggyi'],
  'Nepal': ['Katmandu','Pokhara','Lalitpur','Bharatpur','Birgunj','Biratnagar'],
  'Sri Lanka': ['Colombo','Kandy','Galle','Jaffna','Negombo','Batticaloa','Trincomalee'],
  'Moğolistan': ['Ulan Batur','Erdenet','Darkhan','Çoybalsan'],
  'Afganistan': ['Kabil','Kandahar','Herat','Mazar-ı Şerif','Celalabad','Kunduz'],
  'Somali': ['Mogadişu','Hargeysa','Berbera','Kismayo','Marka','Beledweyne'],
  'Gana': ['Akra','Kumasi','Tamale','Takoradi','Sunyani','Cape Coast'],
  'Senegal': ['Dakar','Thiès','Saint-Louis','Ziguinchor','Kaolack','Mbour'],
  'Tanzanya': ['Dodoma','Dar es Selam','Mwanza','Arusha','Zanzibar','Mbeya'],
  'Uganda': ['Kampala','Gulu','Lira','Mbarara','Jinja','Mbale','Entebbe'],
  'Ruanda': ['Kigali','Butare','Gitarama','Ruhengeri','Gisenyi'],
  'Mozambik': ['Maputo','Matola','Beira','Nampula','Chimoio','Nacala'],
  'Madagaskar': ['Antananarivo','Toamasina','Antsirabe','Fianarantsoa','Mahajanga','Toliara'],
  'Angola': ['Luanda','Huambo','Lobito','Benguela','Lubango','Kuito','Malanje'],
  'Kamerun': ['Yaoundé','Douala','Bamenda','Garoua','Maroua','Bafoussam'],
  'Cibuti': ['Cibuti','Ali Sabieh','Tadjoura','Obock','Dikhil'],
  'Eritre': ['Asmara','Keren','Massawa','Assab','Mendefera'],
};

// Şehir listesini düz array olarak da çek (arama için)
export const ALL_CITIES = Object.entries(CITIES_BY_COUNTRY).flatMap(
  ([country, cities]) => cities.map(city => ({ city, country }))
);
